import { render } from "./ManageTag.vue?vue&type=template&id=16ca5e24"
import script from "./ManageTag.vue?vue&type=script&lang=js"
export * from "./ManageTag.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__